// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure_figure__rVx9_","figure__caption":"Figure_figure__caption__PVrKI","caption":"Figure_caption__p9mrH"};